import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';
import { Logo } from '@/components/layout/Logo';
import { VerdictFooter } from '@/components/verdict';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Simple Header */}
      <header className="border-b border-border">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <Logo size="md" linkTo="/" />
        </div>
      </header>

      {/* 404 Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="text-center max-w-md">
          <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
          <h2 className="text-2xl font-bold mt-4 mb-2">Page Not Found</h2>
          <p className="text-text-secondary mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button variant="primary" leftIcon={<Home className="w-4 h-4" />}>
                Go to Homepage
              </Button>
            </Link>
            <Button 
              variant="secondary" 
              leftIcon={<ArrowLeft className="w-4 h-4" />}
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
          </div>

          <div className="mt-12 text-text-muted text-sm">
            <p>Looking for something specific?</p>
            <div className="flex flex-wrap gap-2 justify-center mt-3">
              <Link to="/pricing" className="text-primary hover:underline">Pricing</Link>
              <span>•</span>
              <Link to="/signup" className="text-primary hover:underline">Sign Up</Link>
              <span>•</span>
              <Link to="/login" className="text-primary hover:underline">Login</Link>
            </div>
          </div>
        </div>
      </main>

      <VerdictFooter />
    </div>
  );
}

